import LoadingButton from "@mui/lab/LoadingButton"
import Autocomplete from "@mui/material/Autocomplete"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"
import { useState } from "react"

import { useAuthorizedAxiosClient } from "../../../common/axios"
import Column from "../../../common/components/Column"
import DialogHeader from "../components/DialogHeader"

export default function DeleteStageDialog({
  open,
  onClose,
  stageToDelete,
  stages,
}) {
  const [moveToStageInputValue, setMoveToStageInputValue] = useState("")
  const [moveToStage, setMoveToStage] = useState(null)
  const [isDeleting, setIsDeleting] = useState(false)
  const axios = useAuthorizedAxiosClient()
  const totalCandidateCount = stageToDelete.totalResults
  const stageHasCandidates = totalCandidateCount > 0

  function handleSoftClose() {
    onClose()
    clearInputs()
  }

  function handleDeleteButtonClicked() {
    setIsDeleting(true)
    axios
      .delete(`/crm/api/crm-stages/${stageToDelete.id}/`, {
        data: { move_to: moveToStage?.id },
      })
      .then(() => {
        clearInputs()
        onClose(true, moveToStage)
      })
  }

  function clearInputs() {
    setMoveToStageInputValue("")
    setMoveToStage(null)
  }

  return (
    <Dialog open={open} onClose={handleSoftClose} maxWidth="xs" fullWidth>
      <DialogHeader title="Delete Pipeline Stage" onClose={handleSoftClose} />
      <DialogContent>
        <Column sx={{ gap: 1 }}>
          <Typography variant="h4" gutterBottom sx={{ alignSelf: "center" }}>
            Are you sure?
          </Typography>
          <Typography variant="body1">
            You're about to delete pipeline stage{" "}
            <strong>{stageToDelete.name}</strong>. This is not reversible.
          </Typography>
          {stageHasCandidates ? (
            <>
              <Typography variant="body1">
                Pipeline stage already has{" "}
                <strong>{totalCandidateCount} candidates</strong>. Select a
                stage to move those candidates to as part of the deletion
                process:
              </Typography>
              <Autocomplete
                inputValue={moveToStageInputValue}
                onInputChange={(e, newValue) =>
                  setMoveToStageInputValue(newValue)
                }
                value={moveToStage}
                onChange={(e, newValue) => setMoveToStage(newValue)}
                options={stages.filter(
                  (stage) => stage.id !== stageToDelete.id
                )}
                getOptionLabel={(option) => option.name}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={`Move ${totalCandidateCount} Candidates To`}
                  />
                )}
                sx={{ mt: 1 }}
              />
            </>
          ) : null}
        </Column>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="error" onClick={handleSoftClose}>
          Cancel
        </Button>
        <LoadingButton
          variant="contained"
          color="error"
          loading={isDeleting}
          disabled={stageHasCandidates && !moveToStage}
          onClick={handleDeleteButtonClicked}
        >
          Delete
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}
